import { StyleSheet } from 'aphrodite';
import { AutomationTemplateViewModel } from '../../../../../extViewmodels';
import {
	Combobox,
	ComboboxContent,
	ComboboxControl,
	ComboboxEmpty,
	ComboboxInput,
	ComboboxItem,
	ComboboxItemRadioIndicator,
	ComboboxList,
	ComboboxValue,
} from '../../../../components-v2/Combobox';

interface Props {
	automationChoices?: AutomationTemplateViewModel[];
	selectedAutomation: AutomationTemplateViewModel | null;
	onSetTemplate?(template: AutomationTemplateViewModel): void;
}

const itemToStringLabel = (automation: AutomationTemplateViewModel | 'None') => {
	if (automation !== 'None') {
		return `${automation.name} (Created by ${automation.creator?.firstName} ${automation.creator?.lastName})`;
	}
	return automation;
};

export const MeetingReminders = ({ automationChoices, selectedAutomation, onSetTemplate }: Props) => {
	const items = ['None', ...automationChoices];
	return (
		<Combobox
			items={items}
			value={selectedAutomation ?? 'None'}
			onValueChange={value => onSetTemplate(value === 'None' ? null : (value as AutomationTemplateViewModel))}
			itemToStringLabel={value => itemToStringLabel(value as AutomationTemplateViewModel)}
			isItemEqualToValue={(item, value) => {
				if (value === 'None' && item === 'None') {
					return true;
				}
				return (item as AutomationTemplateViewModel)?.id === (value as AutomationTemplateViewModel)?.id;
			}}
		>
			<ComboboxControl>
				<ComboboxValue>
					<ComboboxInput placeholder='Select a meeting reminder' styles={[s.input]} />
				</ComboboxValue>
			</ComboboxControl>
			<ComboboxContent>
				<ComboboxEmpty>No meeting reminders found</ComboboxEmpty>
				<ComboboxList>
					{(automation: AutomationTemplateViewModel) => (
						<ComboboxItem key={automation?.id ?? 'meeting-reminders-empty'} value={automation}>
							<ComboboxItemRadioIndicator />
							{itemToStringLabel(automation)}
						</ComboboxItem>
					)}
				</ComboboxList>
			</ComboboxContent>
		</Combobox>
	);
};

const s = StyleSheet.create({
	input: {
		maxWidth: 568,
	},
});
